<div
  class="loading-overlay"
  [class.loading-overlay--exit]="fadeOut()"
  [class.loading-overlay--store]="variant() === 'store'"
  role="status"
  [attr.aria-label]="'Cargando ' + (title() || 'tienda')"
>
  <div class="logo-wrapper" aria-hidden="true">
    <div class="arc arc--outer-b"></div>
    <div class="arc arc--outer-a"></div>
    <div class="arc arc--glow"></div>
    <div class="arc arc--a"></div>
    <div class="arc arc--b"></div>
    <div class="logo-container">
      @if (showLogoImage()) {
        <img
          class="logo"
          [src]="logoSrc()!"
          alt=""
          fetchpriority="high"
          width="72"
          height="72"
          (error)="onLogoError()"
        />
      } @else {
        <span class="logo-monogram">{{ monogram() }}</span>
      }
    </div>
  </div>

  @if (title()) {
    <span class="brand-label">{{ title() }}</span>
  }

  <div class="progress-bar" aria-hidden="true">
    <div class="progress-bar__fill"></div>
  </div>
</div>
